// extracted by mini-css-extract-plugin
export default {"spinnerContainer":"Spinner_spinnerContainer__42kIV","loader":"Spinner_loader__RiOLQ","load1":"Spinner_load1__wpT2n"};